import CountryFlags from "@/modules/authentication/sign-up/components/CountryFlags";


export class PhoneHelper {
	static preparePhoneNumber(value: string, countryCode: string) {
		countryCode = countryCode || 'PH'; // Default to PH if no prefix

		const dialCode = CountryFlags.countries.find(i => i.code == countryCode)?.dialCode || '+63'
		// Validate the phone number
		// Clean the value: remove all non-digits and convert to clean number
		const cleanValue = value?.replace(/\D/g, '') || '';
		return dialCode + cleanValue;
	}
}
